import noop from 'lodash/noop';
import throttle from 'lodash/throttle';

import type { MixpanelEvents } from '../lib/logger/analytics';

export type UserEventProps = Record<
  string,
  string | number | boolean | undefined
>;

type UserEventListener = (
  event: MixpanelEvents,
  props?: UserEventProps
) => void;
let _listener: UserEventListener = noop;

export const setUserEventListener = (listener: UserEventListener) => {
  _listener = listener;
};

const THROTTLE_MS = 60_000;

// One throttle per (event, props) pair rather than one for everything. A single
// global throttle let through one `tooltip open` a minute per user, whichever
// tooltip it was, so nothing could be attributed. The map is bounded by the
// ids callers pass, not by how much the user hovers.
const throttledByKey = new Map<string, () => void>();

export const emitMixpanelUserEvent = (
  event: MixpanelEvents,
  props?: UserEventProps
) => {
  const key = `${event}${JSON.stringify(props ?? {})}`;
  let emit = throttledByKey.get(key);
  if (!emit) {
    emit = throttle(() => _listener(event, props), THROTTLE_MS, {
      leading: true,
      trailing: false,
    });
    throttledByKey.set(key, emit);
  }
  emit();
};
